import transitionEmit from './transitionEmit.js';
export default function transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}


//////////////////
// WEBPACK FOOTER
// /Users/guillaumeluce/Documents/ocean/web/app/themes/akyos-sage/node_modules/swiper/core/transition/transitionEnd.js
// module id = 51
// module chunks = 0